export function productSubscribe($form) {
  const productId = $(".product--single").data("id");
  const variantId = parseInt($("#product-select option:selected").val());
  const email = $form.find('input[type="email"]').val();
  const productQuantity = parseInt(
    $(".product--single .field--quantity").val()
  );
  const requestUrl = `https://app.backinstock.org/stock_notification/create.json?shop=${window.location.host}&notification[email]=${email}&notification[product_no]=${productId}&notification[quantity_required]=${productQuantity}&notification[accepts_marketing]=true&variant[variant_no]=${variantId}`;

  $.ajax({
    url: requestUrl,
    type: "get"
  }).done(data => {
    if (data.status !== "Error") {
      $("#popup-back-in-stock .popup__inner").addClass("submitted");
    } else {
      $("#popup-back-in-stock .popup__inner")
        .addClass("error")
        .find(".form__error")
        .html(data.errors.email[0]);
    }
  });
}
